




































import Vue from "vue";
import { FileRepresentation } from "../interfaces/DcmDocumentListConfiguration";
import { DcmFormMetadata } from "../interfaces/DcmDocumentListConfiguration";
import { DcmService, FileService } from "../services";
export default Vue.extend({
  props: {
    title: String,
    formMetadatas: Array as () => DcmFormMetadata[] | undefined,
    staticMetadatas: Object as () => { [key: string]: any },
    dcmName: Boolean,
    path: String
  },
  data() {
    return {
      files: [] as File[]
    };
  },
  computed: {
    isValid: function() {
      if(this.files.length == 0) {
        return false;
      }
      if(this.formMetadatas) {
        for (const formMetadata of this.formMetadatas) {
          if(formMetadata.required && !formMetadata.value) {
            return false;
          }
        }
      }
      return true;
    }
  },
  methods: {
    async submit() {
      for (const file of this.files) {
        await this.createDocument(file);
      }
      this.$modal.close(true);
    },
    async createDocument(file: File) {
      const metadatas : { [key: string]: any } = Object.assign(this.staticMetadatas);
      if(this.formMetadatas) {
        for (const formMetadata of this.formMetadatas) {
          if(formMetadata.value) {metadatas[formMetadata.key] = formMetadata.value;}
        }
      }
      /*
      const fileRepresentation: FileRepresentation = await FileService.convertToFileRepresentation(
        file,
        file.name,
        metadatas
      );

      await DcmService.createDocument(fileRepresentation, this.path);*/
      await DcmService.createDocument(file, metadatas, this.path)
    },
  },
});
